import * as classNames from 'classnames'
import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import CreateTrip from '../../containers/trips/CreateTrip'
import FullListActiveTrips from '../../containers/trips/FullListActiveTrips'
import Trips from '../../containers/trips/Trips'
import UserTopPanel from '../../containers/trips/UserTopPanel'
import TripDetailPane from '../../containers/trips/TripDetailPane'
import RiderRecentTrips from '../../containers/trips/RiderRecentTrips'
import { IActiveTripResponseV2, ICoordinates, IZoneObject, ITripFilters } from '../../types'
import MapView from '../../containers/googleMap/GoogleMaps'
import LiveDriversPane from '../../containers/drivers/LiveDriversPane'
import { mapViewStrategyStages } from '../MapView'
import ErrorBoundary from '../ErrorBoundary'
import SetTripPassengerModal from './modal/SetTripPassengerModal'

const TripsWrap = (props: RouteComponentProps<any>) => <Trips {...props} />

const CreateTripPane = (props: RouteComponentProps<any>) => {
  return (
    <ErrorBoundary>
      <React.Fragment>
        <UserTopPanel riderId={props.match.params.riderId} />
        <CreateTrip {...props} />
      </React.Fragment>
    </ErrorBoundary>
  )
}

export interface ITripsPaneProps extends RouteComponentProps {
  origin: ICoordinates | null
  destination: ICoordinates | null
  polylines: string | null
  currentUserId: string | undefined
  currentOrganizationId: string
  showMembers: boolean
  updateTrip: (trip: IActiveTripResponseV2) => void
  clearMap: () => void
  tripFilters?: ITripFilters
  zones: { [key: string]: IZoneObject } | {}
  getGoinzones?: (orgId: string, serviceId: string) => Promise<any>
  getAllGoinzones?: (orgId: string) => Promise<any>
  toggleZone?: (zone: { [key: string]: IZoneObject } | {}) => Promise<any>
  visible: boolean
  setCurrentTripStage: (stage: string) => Promise<any>
}

class TripsPane extends React.Component<ITripsPaneProps> {
  constructor(props: any) {
    super(props)
  }

  public componentWillUnmount() {
    this.props.clearMap()
  }

  public componentDidMount() {
    this.fetchGoinZones()
    this.props.setCurrentTripStage(mapViewStrategyStages.showNearbyDrivers)
  }

  public fetchGoinZones() {
    if (this.props.toggleZone) {
      this.props.toggleZone({})
    }
    if (
      this.props.getGoinzones &&
      this.props.tripFilters &&
      this.props.tripFilters.orgId &&
      this.props.tripFilters.serviceId
    ) {
      this.props.getGoinzones(
        this.props.tripFilters && this.props.tripFilters.orgId ? this.props.tripFilters.orgId : '',
        this.props.tripFilters && this.props.tripFilters.serviceId ? this.props.tripFilters.serviceId : ''
      )
    } else if (this.props.getAllGoinzones) {
      this.props.getAllGoinzones(this.props.currentOrganizationId)
    }
  }

  public componentDidUpdate(prevProps: ITripsPaneProps) {
    if (
      this.props.toggleZone &&
      this.props.zones &&
      JSON.stringify(prevProps.zones) !== JSON.stringify(this.props.zones)
    ) {
      if (this.props.tripFilters && this.props.tripFilters.orgId && !this.props.tripFilters.serviceId) {
        this.props.toggleZone(this.setAllZonesVisible(this.props.zones, this.props.visible))
      } else {
        this.props.toggleZone(this.setAllZonesVisible(this.props.zones, true))
      }
    }

    if (
      prevProps.tripFilters &&
      this.props.tripFilters &&
      prevProps.tripFilters.serviceId !== this.props.tripFilters.serviceId
    ) {
      this.fetchGoinZones()
    }
  }

  public render() {
    const setTripPassengerModal = (props: any) => {
      return <SetTripPassengerModal {...props} />
    }
    return (
      <ErrorBoundary>
        <section className='TripsPane'>
          <div
            className={classNames('shadow-right bg-white overflow-y-scroll overflow-x-hidden', {
              TripControlsWithMembers: this.props.showMembers,
              TripControls: !this.props.showMembers
            })}
          >
            <Switch>
              <Route path={`${this.props.match.path}/full-list-active-trips`} component={FullListActiveTrips} />
              <Route path={`${this.props.match.path}/create/:riderId`} component={this.CreateTripPane} />
              <Route path={`${this.props.match.path}/recent/:riderId`} component={RiderRecentTrips} />
              <Route path={`${this.props.match.path}/:tripId`} component={TripDetailPane} />
              <Route path={`${this.props.match.path}`} component={TripsWrap} />
            </Switch>
          </div>
          <MapView zones={this.props.zones} isDraggable={/trips\/create/.test(this.props.location.pathname)} />
          <LiveDriversPane hidden={this.props.showMembers} />
        </section>
      </ErrorBoundary>
    )
  }

  private setAllZonesVisible = (zones: { [key: string]: IZoneObject } | {}, status: boolean) => {
    for (const i of Object.keys(zones)) {
      zones[i].visible = status
    }
    return zones
  }

  private CreateTripPane = (props: RouteComponentProps<any>) => {
    return CreateTripPane({ ...props })
  }
}

export default TripsPane



// WEBPACK FOOTER //
// ./src/components/trips/TripsPane.tsx